<template>
  <section class="section" id="stores">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h1 class="title has-text-centered">
      {{ `${stores.length} ${$tc("dashboard.stores", stores.length)}` }}
    </h1>

    <div class="block has-text-centered">
      {{ $t("dashboard.showStoresInOrder") }}
      &nbsp;&nbsp;
      <span style="position: relative; top: 0.25rem">
        <b-radio
          v-model="preferences.storesOrder"
          name="preferences.storesOrder"
          native-value="chronological"
          @input="updateStoresOrderPreference"
        >
          {{ $t("dashboard.chronological") }}
        </b-radio>
        <b-radio
          v-model="preferences.storesOrder"
          name="preferences.storesOrder"
          native-value="alphabetical"
          @input="updateStoresOrderPreference"
        >
          {{ $t("dashboard.alphabetical") }}
        </b-radio>
      </span>
    </div>

    <div class="columns is-multiline">
      <div
        v-for="store in orderedStores"
        :key="store._id"
        class="column is-one-third-desktop is-half-tablet"
      >
        <store-card
          :store="store"
          @open-cashback-modal="openCashbackModal"
          @open-coupon-modal="openCouponModal"
        />
      </div>
    </div>

    <b-modal :active.sync="isCashbackModalOpen" has-modal-card>
      <cashback-modal :cashbacks="cashbacks" />
    </b-modal>

    <b-modal :active.sync="isCouponModalOpen" has-modal-card>
      <coupon-modal :coupons="coupons" />
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import storeCard from "./StoreCard";
import cashbackModal from "./store-card/CashbackModal";
import couponModal from "./store-card/CouponModal";

export default {
  mixins: [common],

  components: {
    storeCard,
    cashbackModal,
    couponModal
  },

  data() {
    return {
      isLoading: false,
      isCashbackModalOpen: false,
      cashbacks: [],
      isCouponModalOpen: false,
      coupons: []
    };
  },

  methods: {
    getStores() {
      this.isLoading = true;
      this.$store
        .dispatch("getStores")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    openCashbackModal(cashbacks) {
      this.cashbacks = cashbacks;
      this.isCashbackModalOpen = true;
    },

    openCouponModal(coupons) {
      this.coupons = coupons;
      this.isCouponModalOpen = true;
    },

    updateStoresOrderPreference() {
      this.$store
        .dispatch("updateStoresOrderPreference", {
          storesOrder: this.preferences.storesOrder
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    }
  },

  computed: {
    ...mapGetters(["stores", "preferences"]),

    orderedStores() {
      return this.preferences.storesOrder === "alphabetical"
        ? [...this.stores].sort((a, b) => {
            return a.storeInfo.name.localeCompare(b.storeInfo.name);
          })
        : this.stores;
    }
  },

  mounted() {
    this.$store.dispatch("setStoreBeingManaged", null).catch(() => {
      this.alertError({ message: "UNEXPECTED_ERROR" });
    });
    this.getStores();
  }
};
</script>

<style scoped>
#stores {
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
